

























































import { mapGetters } from 'vuex';
export default {
	name: 'BottomNav',

	data(){
		return{
			showAdditional: false,
		}
	},

	computed: {
		...mapGetters('cv-profile', {
			currentTab: 'getCurrentTab',
		}),

		showEventsLink(){
			return this.$store.getters['workshops/getShowWorkshopsLink'];
		},

		tabs() {
			let arr = [
				{
					icon: 'home-filled-icon',
					text: 'All Jobs',
					path: '/jobs',
					active:
						this.$route.path === this.localePath({ path: '/jobs' }),
				},
				{
					icon: 'job-filled-icon',
					text: 'My Jobs',
					path: '/my-jobs',
					active:
						this.$route.path ===
						this.localePath({ path: '/my-jobs' }),
				},
				{
					icon: 'document-duplicate-solid',
					text: 'Applications',
					path: '/jobs/applications',
					active:
						this.$route.path ===
						this.localePath({ path: '/jobs/applications' }),
				},
				{
					icon: 'ellipsis',
					text: this.showAdditional ? 'Less' :'More',
					path: null,
					active: false
				},
			];

			if(this.showEventsLink){
				arr.splice(3, 0, {
					icon: 'academic-cap',
					text: 'Events',
					path: '/events',
					active:
						this.$route.path ===
						this.localePath({ path: '/events' }),
				})
			}else{
				arr.splice(3, 0, {
					icon: 'chat-bubble-left-right-solid',
					text: 'Interviews',
					path: '/interviews',
					active:
						this.$route.path ===
						this.localePath({ path: '/interviews' }),
				})
			}

			return arr;
		},

		additionalTabs(){
			let arr = [
				{
					icon: 'book-open-solid',
					text: 'Resources',
					path: '/courses',
					active:
						this.$route.path ===
						this.localePath({ path: '/courses' }),
				},
				{
					icon: 'save-icon',
					text: 'Saved',
					path: '/saved-jobs',
					active:
						this.$route.path ===
						this.localePath({ path: '/saved-jobs' }),
				},
				{
					icon: 'academic-cap',
					text: 'Bursaries',
					path: '/bursaries',
					active:
						this.$route.path ===
						this.localePath({ path: '/bursaries' }),
				},
			];

			if(this.showEventsLink){
				arr.splice(0, 0, {
					icon: 'chat-bubble-left-right-solid',
					text: 'Interviews',
					path: '/interviews',
					active:
						this.$route.path ===
						this.localePath({ path: '/interviews' }),
				})
			}

			arr.push({
				icon: 'trophy',
				text: 'Awards',
				path: '/profile/cv',
				active:
					this.$route.path ===
					this.localePath({ path: '/profile/cv' }) && this.currentTab === 'employability-awards',
			})

			return arr;
		},

		courseCollection() {
			return this.$store.getters['courses/getCourses'];
		},

		workshopCollection() {
			return this.$store.getters['workshops/getWorkshops'];
		},

		//Check if we have a course with a created at date after last week date
		newCourses(){
			let oneWeek = this.$dayjs().subtract(1, 'week');
			return this.courseCollection?.data?.filter((course) => this.$dayjs( this.$dayjs(course.created_at)).isAfter(oneWeek)).length > 0 || false;
		},

		newWorkshops() {
			let oneWeek = this.$dayjs().subtract(1, 'week');

			return this.workshopCollection?.data?.filter((workshop) => this.$dayjs(this.$dayjs(workshop.created_at)).isAfter(oneWeek)).length > 0 || false;
		},
	},

	methods: {
		goToPage(page) {
			if(page){
				if (page.includes('profile/cv')) {
					this.$store.dispatch(
						'cv-profile/setCurrentTab',
						'employability-awards',
					);
				}
				this.$router.push(this.localePath({ path: page }));

				this.showAdditional = false;
			}else{
				this.showAdditional = !this.showAdditional
			}

		},
	},
};
